import React from 'react'
import PageTitle from '../../components/PageTitle'
import { useParams } from 'react-router-dom'
import GeotechnicalInvestigation from './components/GeotechnicalInvestigation';
import CalibrationServices from './components/CalibrationServices';
import MaterialTestingServicesSoil from './components/MaterialTestingServicesSoil';
import MaterialTestingServicesAsphalt from './components/MaterialTestingServicesAsphalt';
import MaterialTestingServicesConcrete from './components/MaterialTestingServicesConcrete';
import MaterialTestingServicesSteel from './components/MaterialTestingServicesSteel';
import NonDestructiveTestingServices from './components/NonDestructiveTestingServices';
import TurnaroundShutdownInspectionSupport from './components/TurnaroundShutdownInspectionSupport';
import InspectionTrainingDivision from './components/InspectionTrainingDivision';
import ThirdPartyInspectionServices from './components/ThirdPartyInspectionServices';
import useServiceTemplate from '../../hooks/templates/useServiceTemplate';

const ServiceDetail = () => {
    const {slug}=useParams();
    useServiceTemplate();
  return (
    <>
    <PageTitle title="Service Detail" />
    {slug==="geotechnical-investigation" && <GeotechnicalInvestigation />}
    {slug==="calibration-services" && <CalibrationServices />}
    {slug==="material-testing-services-soil" && <MaterialTestingServicesSoil />}
    {slug==="material-testing-services-asphalt" && <MaterialTestingServicesAsphalt />}
    {slug==="material-testing-services-concrete" && <MaterialTestingServicesConcrete />}
    {slug==="material-testing-services-steel" && <MaterialTestingServicesSteel />}
    {slug==="non-destructive-testing-ndt" && <NonDestructiveTestingServices />}
    {slug==="turnaround-and-shutdown-inspection-support" && <TurnaroundShutdownInspectionSupport />}
    {slug==="third-party-inspection-services" && <ThirdPartyInspectionServices />}
    {slug==="inspection-and-training-division" && <InspectionTrainingDivision />}
    </>
  )
}

export default ServiceDetail